import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    colorAnchor?: boolean;
  }>()
  .create(({ theme, colorAnchor }) => {
    return {
      link: {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        width: '100%',
        color: colorAnchor
          ? theme.vars.palette.primary.light
          : theme.vars.palette.text.primary,
        textDecoration: 'none'
      }
    };
  });

export default useStyles;
